import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faXTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons'

export default function SocialHeader() {
    return (
      <>
  <ul className="social header">
  
    
  <li>
    
    <a href="https://www.facebook.com/spidersnet/" target="_blank" className="ga-header">
    

    <div className="vocabulary-social-media">

        <div className="l-taxonomy-term-social-media__icon">
          <div className="field field-name-field-icon">
            <FontAwesomeIcon icon={faFacebookF} className="fa-fw" />
          </div>
        </div>

    </div>

    
    </a>
    

  </li>



  <li>
    
    <a href="https://twitter.com/spidersnetUK" target="_blank" className="ga-header">
    

    <div className="vocabulary-social-media">

        <div className="l-taxonomy-term-social-media__icon">
          <div className="field field-name-field-icon">
          <FontAwesomeIcon icon={faXTwitter} className="fa-fw" />
          </div>
        </div>

    </div>

    
    </a>
    

  </li>



  <li>
    
    <a href="https://www.instagram.com/spidersnetuk/" target="_blank" className="ga-header">
    

    <div className="vocabulary-social-media">

        <div className="l-taxonomy-term-social-media__icon">
          <div className="field field-name-field-icon">
          <FontAwesomeIcon icon={faInstagram} className="fa-fw" />
          </div>
        </div>

    </div>

    
    </a>
    

  </li>




</ul>
      </>
    );
  }
  
